/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';

import { IFieldProps, monthlyOptions, monthOptions } from '../../AllSchedules.Model';

import { Options } from '../../../../../../Shared/Components/Common/Dropdown/Dropdown.styles';
import { wrapperStyles } from '../../AllJobs.Style';

const { textField } = wrapperStyles;

export const MonthField = ({ control, quarterName, onFieldChange, selectProps, createSchedule }: IFieldProps) => {
  const optionsForQuarter = monthlyOptions[quarterName as keyof typeof monthlyOptions] || [];

  return (
    <Controller
      name={`quarters.${quarterName}.month`}
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          select
          label="Month"
          fullWidth
          sx={{ ...textField, width: '22.5rem', marginRight: '1.5rem' }}
          SelectProps={selectProps}
          onChange={(e) => {
            field.onChange(e);
            onFieldChange?.('month', e.target.value);
          }}>
          {createSchedule
            ? optionsForQuarter.map((m) => (
                <Options key={m} value={m}>
                  {m}
                </Options>
              ))
            : monthOptions.map((m) => (
                <Options key={m} value={m}>
                  {m}
                </Options>
              ))}
        </TextField>
      )}
    />
  );
};
